import React, { useState, useMemo } from "react";
import { useDashboardState } from "components/DashboardContext";
import "./SidebarDropdown.scss";

import UniversalInput from "components/uiComponents/UniversalInput";
import UniversalCheckbox from "components/uiComponents/UniversalCheckbox";

import { ReactComponent as SearchIcon } from "static/icons/search-grey.svg";
import classNames from "classnames";

const SidebarDropdown = ({
    commonOptions = [],
    uncommonOptions = [],
    selectedItems,
    optionsType,
    onChangeSelectedItems,
}) => {
    const {
        setCheckSidebarDropdownStatus,
    } = useDashboardState();

    const [search, setSearch] = useState('');
    const [isUncommonVisible, setIsUncommonVisible] = useState(false);

    const addAlphabetToOptions = opts => {
        const alphabet = [];
        const options = [];

        if (opts?.length) {
            opts.forEach(item => {
                const firstChar = item.charAt();

                if (alphabet.includes(firstChar)) {
                    options.push({
                        value: item,
                        key: item,
                        firstChar: null,
                    });
                } else {
                    alphabet.push(firstChar);
                    options.push({
                        value: item,
                        key: item,
                        firstChar: firstChar,
                    });
                }
            });
        }

        return options;
    };

    const commonOptionsUpd = useMemo(() => {
        return addAlphabetToOptions(commonOptions);
    }, [commonOptions]);

    const uncommonOptionsUpd = useMemo(() => {
        return addAlphabetToOptions(uncommonOptions);
    }, [uncommonOptions]);

    const searchedOptions = useMemo(() => {
        if (search) {
            const searchItem = search.toLowerCase();

            return [...commonOptionsUpd, ...uncommonOptionsUpd].filter(item => {
                const loweredItem = item.value.toLowerCase();

                return loweredItem.indexOf(searchItem) >= 0;
            });
        }

        return null;
    }, [search, commonOptions, uncommonOptions]);

    const handleSearchChange = value => {
        setSearch(value);
    };

    const handleSwitcherClick = () => {
        setIsUncommonVisible(!isUncommonVisible);
        setCheckSidebarDropdownStatus(true);
    };

    const handleClearSearch = () => {
        setSearch('');
    };

    return (
        <div className="sidebar-dropdown">
            <div className="sidebar-dropdown__search_container">
                <UniversalInput
                    leftIcon={
                        <SearchIcon className="sidebar-dropdown__search_icon" />
                    }
                    name="search"
                    type="text"
                    id="search"
                    placeholder="Search"
                    onChangeValue={handleSearchChange}
                    value={search}
                    isClearButtonActive
                    onClearSearch={handleClearSearch}
                    required
                />
            </div>

            <div className="sidebar-dropdown__options_container">
                {!search && 
                !!commonOptionsUpd.length &&
                    <div
                        className={classNames({
                            'sidebar-dropdown__options': true,
                            'sidebar-dropdown__options_common': isUncommonVisible,
                        })}
                    >
                        {commonOptionsUpd.map(option => {
                            const handleCheckboxChange = () => {
                                onChangeSelectedItems(option.value, optionsType);
                            };

                            return (
                                <div
                                    key={option.value}
                                    className="sidebar-dropdown__option_wrapper"
                                >
                                    <div className="sidebar-dropdown__option_char">
                                        {option.firstChar}
                                    </div>

                                    <div className="sidebar-dropdown__option">
                                        <UniversalCheckbox
                                            name={option.key}
                                            label={option.value}
                                            onChange={handleCheckboxChange}
                                            checked={selectedItems?.some(item => item === option.value)}
                                        />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                }

                {((
                    isUncommonVisible && 
                    !search && 
                    !!uncommonOptionsUpd.length && 
                    !!commonOptionsUpd.length
                ) || (
                    !search && 
                    !commonOptionsUpd.length &&
                    !!uncommonOptionsUpd.length
                )) &&
                    <>
                        {!!commonOptionsUpd.length &&
                            <div
                                className="sidebar-dropdown__options_line"
                            />
                        }

                        <div className="sidebar-dropdown__options">
                            {uncommonOptionsUpd.map(option => {
                                const handleCheckboxChange = () => {
                                    onChangeSelectedItems(option.value, optionsType);
                                };

                                return (
                                    <div
                                        key={option.value}
                                        className="sidebar-dropdown__option_wrapper"
                                    >
                                        <div className="sidebar-dropdown__option_char">
                                            {option.firstChar}
                                        </div>

                                        <div className="sidebar-dropdown__option">
                                            <UniversalCheckbox
                                                name={option.key}
                                                label={option.value}
                                                onChange={handleCheckboxChange}
                                                checked={selectedItems?.some(item => item === option.value)}
                                            />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </>
                }

                {!!search &&
                    <div
                        className={classNames({
                            'sidebar-dropdown__options': true,
                            'sidebar-dropdown__options_common': isUncommonVisible,
                        })}
                    >
                        {searchedOptions.map(option => {
                            const handleCheckboxChange = () => {
                                onChangeSelectedItems(option.value, optionsType);
                            };

                            return (
                                <div
                                    key={option.value}
                                    className="sidebar-dropdown__option_wrapper"
                                >
                                    <div className="sidebar-dropdown__option_char" />

                                    <div className="sidebar-dropdown__option">
                                        <UniversalCheckbox
                                            name={option.key}
                                            label={option.value}
                                            onChange={handleCheckboxChange}
                                            checked={selectedItems?.some(item => item === option.value)}
                                        />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                }
            </div>

            {!search &&
            !!uncommonOptionsUpd.length && 
            !!commonOptionsUpd.length &&
                <div
                    className="sidebar-dropdown__options_switcher"
                    onClick={handleSwitcherClick}
                >
                    {isUncommonVisible
                        ? 'Show less'
                        : 'Show all'
                    }
                </div>
            }
        </div>
    );
};

export default SidebarDropdown;
